import { render, staticRenderFns } from "./RebateList-Rebate.vue?vue&type=template&id=5dba0caa&scoped=true"
import script from "./RebateList-Rebate.vue?vue&type=script&lang=js"
export * from "./RebateList-Rebate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dba0caa",
  null
  
)

export default component.exports